<script>
  import {getContext} from 'svelte';
  import {Button} from '@px/button';
  import {goto} from '@sapper/app';
  import {PATHS} from '@/const/paths';
  import {envUtil} from '@/helper/env';
  import {fixLink$} from '@/store/lang';
  import {IMAGES} from '@/modules/homepage/images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');
  const backgroundImage = envUtil.isMobile ? `background: var(--blue)` : `background: url("${IMAGES.KNOWLEDGE_BG}") no-repeat center center/auto 100% var(--blue);`;

  function handleClick() {
    goto($fixLink$(PATHS.LEARN_CRYPTO.pathname));
  }
</script>

<style>
  .main {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 40px;
    width: 1200px;
  }
  .title {
    margin-top: 0;
    font-size: 48px;
  }
  .main :global(button) {
    height: 64px;
  }
  @media screen and (max-width: 640px) {
    .main {
      width: 100%;
    }
    .title {
      line-height: 30px;
      font-size: 24px;
    }
    .subtitle {
      line-height: 20px;
    }
  }
</style>

<section style={backgroundImage}>
  <div class="main tc TW">
    <h2 class="title mb12">{LG(lang.SharingCryptoKnowledge)}</h2>
    <div class="subtitle mb28">{LG(lang.FreeAndComprehensive)}</div>
    <Button type="default" class="fw3" size="large" on:click={handleClick}>{LG(lang.LearnAboutCrypto)}</Button>
  </div>
</section>
